// Утилиты для формирования URL изображений
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (/^https?:\/\//.test(imagePath)) return imagePath;
  const cleanPath = String(imagePath).replace(/^\/+/, '');
  return `/static/${cleanPath}`;
};

export const getStaticPath = (imagePath) => {
  if (!imagePath) return '';
  if (/^https?:\/\//i.test(String(imagePath))) return imagePath;
  return `/static/${String(imagePath).replace(/^\/+/, '')}`;
};

// Базовый путь ресайзера: /api/img проксируется nginx вместе с API (в отличие от /img)
const getImageResizeBasePath = () => '/api/img';

// Серверный ресайзер: /api/img?f=...&w=400
export const getResizedUrl = (imagePath, width = 400, fmt = 'auto') => {
  if (!imagePath) return '';
  if (/^https?:\/\//i.test(String(imagePath))) {
    return String(imagePath);
  }
  const file = String(imagePath)
    .replace(/^\/static\//, '')
    .replace(/^\/+/, '');
  const params = new URLSearchParams({
    f: file,
    w: String(width),
    fmt,
  });
  return `${getImageResizeBasePath()}?${params.toString()}`;
};

export const getThumbUrl = (imagePath, width = 400, fmt = 'auto') => {
  if (!imagePath) return '';
  if (/^https?:\/\//i.test(String(imagePath))) {
    return String(imagePath);
  }
  const base = String(imagePath).replace(/^\/static\//, '').replace(/^\/+/, '');
  const dotIdx = base.lastIndexOf('.');
  const name = dotIdx !== -1 ? base.slice(0, dotIdx) : base;

  if (fmt === 'thumb') {
    return `/static/${name}_thumb.webp`;
  }

  if (fmt === 'orig') {
    return `/static/${base}`;
  }

  return getResizedUrl(base, width, fmt);
};

// Превью через /api/img; staticUrl — запасной URL (/static) при ошибке загрузки
export const buildPictureSources = (imagePath, width = 400) => {
  if (!imagePath) {
    return { avif: undefined, webp: undefined, fallback: '', staticUrl: '' };
  }
  if (/^https?:\/\//i.test(String(imagePath))) {
    const url = String(imagePath);
    return {
      avif: undefined,
      webp: undefined,
      fallback: url,
      staticUrl: url,
    };
  }
  return {
    avif: undefined,
    webp: undefined,
    fallback: getResizedUrl(imagePath, width, 'auto'),
    staticUrl: getImageUrl(imagePath),
  };
};
